// @flow
import React from 'react';
import styled from 'styled-components';
import { media } from 'styles/Mixins';
import { HomeApplication } from 'utils/ExportCommon';
import { font } from 'styles/Constants';

const ModalWindow = styled.div`
  display: ${props => (props.visible ? 'block' : 'none')};
  position: fixed;
  z-index: 100;
  padding-top: 100px;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.4);
`;

const ModalContent = styled.div`
  background-color: #fefefe;
  margin: auto;
  padding: 40px 50px;
  border: 1px solid #888;
  color: red;
  width: 500px;
  border-radius: 2px;
  background-color: #278c7e;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  ${media.xs`
    width: 345px;
    min-height: 324px;
    padding: 30px 45px;
  `}
`;

const ImgContent = styled.div`
  margin-left: calc(50% - 82.5px);
  height: 165px;
  width: 165px;
  background-color: #ffffff;
  border-radius: 50%;
  ${media.xs`
    margin: 0 auto;
  `}
`;

const TextModal = styled.div`
  color: #ffffff;
  font-family: ${font.openSans};
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  margin-top: 20px;
  ${media.xs`
    width: 100%;
  `}
`;

const UserOptions = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 32px;
`;

const UserOption = styled.button`
  background-color: ${props => (props.transparent ? 'transparent' : '#fff')};
  color: ${props => (props.transparent ? '#fff' : '#278C7E')};
  outline: none;
  border: none;
  font-size: 16px;
  font-weight: bold;
  border-radius: 2px;
  line-height: 17px;
  padding: 8px ${props => (props.transparent ? '0' : '16px')};
`;

type State = {};

type PropsType = {
  visible: boolean,
  onClickButtonContinue: () => void,
  onClickButtonCancel: () => void
};

export default class CancelHomieApplicationConfirmationModal extends React.Component<
  PropsType,
  State
> {
  render() {
    const { visible, onClickButtonContinue, onClickButtonCancel } = this.props;

    return (
      <div>
        <ModalWindow visible={visible}>
          <ModalContent>
            <ImgContent>
              <img
                style={{
                  height: '100px',
                  marginTop: '35px',
                  marginLeft: '32px'
                }}
                src={HomeApplication.ThinkingFace}
              />
            </ImgContent>
            <TextModal>
              ¿Estas seguro que deseas cancelar la aplicación para este
              departamento?
            </TextModal>
            <UserOptions>
              <UserOption onClick={onClickButtonContinue} transparent>
                Continuar la aplicación
              </UserOption>
              <UserOption onClick={onClickButtonCancel}>
                Cancelar aplicación
              </UserOption>
            </UserOptions>
          </ModalContent>
        </ModalWindow>
      </div>
    );
  }
}
